/*
  作者：zhang.qiang
  时间：2017-3-3
  描述：采编中心-app渠道-编辑器多图上传弹窗控制器
*/
'use strict';
angular.module('uploadPicturesModule', []).controller('uploadPicturesCtrl', [
    '$scope',
    '$q',
    '$modalInstance',
    '$templateRequest',
    '$timeout',
    'params',
    'modalDialog',
    'trsHttpService',
    function($scope, $q, $modalInstance, $templateRequest, $timeout, params, modalDialog, trsHttpService) {
        initStatus();
        initData();

        function initStatus() {
            $scope.data = {
                picList: [],
                navs: [
                    { name: '我的图片', value: '1' },
                    { name: '本地图片', value: '2' },
                ],
                selectedNav: [],
                myPictures: [], // 素材库列表
                selectedArray: [], // 我的图片选中图片
                currFileId: '0', // 当前文件夹的id
                keywords: '', // 检索关键词
                uploadImgs: [],
                uploadedSrcs: [],
                progress: {},
                PersonalMaterialOfImgs: [],
            };
            $scope.page = {
                ITEMCOUNT: '0',
                CURRPAGE: '1',
                PAGESIZE: '20',
                PAGECOUNT: '1',
            };
            $scope.status = {
                maxSize: 20, // 单图最大尺寸 单位MB
                scaleWidth: 700, // 缩放宽度
                isAddPersonalMaterial: true,
            };
            $scope.params = {
                serviceid: 'mlf_releaseSource', // 服务名
                methodname: 'queryPersonalMaterials', // 方法名
                PersonalMaterialId: '0', // 主键，唯一性
                status: '0', // 正常
                fileType: '2', // 数据类型
                order: '0', // 0：按创建时间排序，1：显示名称排序
                searchValue: '', // 搜索内容
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
            };
            $scope.data.selectedNav = $scope.data.navs[0].value;
            initInputFile();
        }

        function initInputFile() {
            $scope.status.file = $(document.createElement('input'));
            $scope.status.file.attr({
                type: 'file',
                name: 'file',
                class: 'webuploader-element-invisible',
                multiple: 'file',
                accept: '.gif,.jpg,.jpeg,.bmp,.png,.eps',
            });
            $scope.status.file[0].onchange = function() {
                var self = this;
                $timeout(function() {
                    for (var i = 0; i < self.files.length; i++) {
                        if (self.files[i].type.split('/')[0] == 'image' || self.files[i].type == 'application/postscript') {
                            $scope.data.picList.push(self.files[i]);
                        } else {
                            modalDialog.alertType('请上传符合格式要求的文件', '', 'error', 'confirm');
                        }
                    }
                    initInputFile();
                    getContentHeight();
                });
            };
        }

        /**
         * [cancel 关闭]
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [changeNav 切换导航]
         * @return {[type]} [description]
         */
        $scope.changeNav = function(nav) {
            $scope.data.selectedNav = nav.value;
            getContentHeight();
        };

        /**
         * [choosePics 上传图片]
         * @return {[type]} [description]
         */
        $scope.choosePics = function() {
            // $("#file")[0].click();
            $scope.status.file[0].click();
        };

        /**
         * [deletePic 删除图片]
         * @return {[int]} index [description] //删除图片的序号
         */
        $scope.deletePic = function(index) {
            $scope.data.picList.splice(index, 1);
            getContentHeight();
        };

        /**
         * [getPreviewUrl ]获取图片预览地址
         * @params {[object]} item [description] 图片文件对象
         * @return {[type]} [description]
         */
        $scope.getPreviewUrl = function(item) {
            if (!!item.isSuCaiKu) {
                return;
            } else {
                item.previewSrc = URL.createObjectURL(item);
            }
        };

        /**
         * [getPicsSize] 获取选中图片的总大小
         * @return {[type]} [description]
         */
        $scope.getPicsSize = function() {
            return (function() {
                var size = 0;
                for (var i = 0; i < $scope.data.picList.length; i++) {
                    size += $scope.data.picList[i].size;
                }
                return Math.round((size / 1024 / 1024) * 100) / 100;
            })();
        };

        /**
         * [uploadPics] 开始上传图片
         * @return {[type]} [description]
         */
        $scope.uploadPics = function() {
            for (var i = 0; i < $scope.data.picList.length; i++) {
                if (angular.isUndefined($scope.data.picList[i].realSrc)) {
                    uploadPic(
                        $scope.data.picList[i],
                        i,
                        function(data, index) {
                            $timeout(function() {
                                $scope.data.picList[index].progress = Math.round((data.loaded / data.total) * 100) + '%';
                            });
                        },
                        function(data, index) {
                            $scope.data.picList[index].realSrc = '/wcm/file/read_image.jsp?FileName=' + JSON.parse(data).imgName;
                            $scope.$apply(function() {
                                if (angular.isDefined(JSON.parse(data).error)) {
                                    modalDialog.alertType(JSON.parse(data).error, '', 'error', 'confirm');
                                    $scope.data.picList[index].error = JSON.parse(data).error;
                                    return;
                                }
                            });

                            /* scaleImg(JSON.parse(data).imgName).then(function(_data) {  //取消真实缩放图片，改为由外部样式来控制
                            $timeout(function() {
                                $scope.data.picList[index].realSrc = "/wcm/file/read_image.jsp?FileName=" + _data.FN;
                            });
                        });*/
                        },
                        function(data, index) {
                            $scope.data.picList[index].error = data;
                        },
                        function(data, index) {
                            $scope.data.PersonalMaterialOfImgs[index] = data;
                        }
                    );
                }
            }
        };

        /**
         * [getAllPercent] 获取总体上传进度
         * @return {[type]} [description]
         */
        $scope.getAllPercent = function() {
            var percent = 0;
            for (var i = 0; i < $scope.data.picList.length; i++) {
                var picFile = $scope.data.picList[i];
                if (picFile.progress !== undefined) {
                    percent += parseFloat(picFile.progress.replace(/%/g, '')) / $scope.data.picList.length;
                }
            }
            return Math.round(percent) + '%';
        };

        /**
         * [uploadPic] 上传图片
         * $param {[fn]} onProgress 上传进度回调函数
         * @param {[fn]} onload [description] 上传完成回调函数
         * @return {[type]} [description]
         */
        function uploadPic(fileInfo, index, onProgress, onload, onerror, isPersonal) {
            if (fileInfo.size / 1024 / 1024 > $scope.status.maxSize) {
                onerror('图片不能超过' + $scope.status.maxSize + 'M', index);
                return;
            }
            var fd = new FormData();
            fd.append('file', fileInfo);
            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/wcm/openapi/uploadImage?AddPersonalMaterial=' + $scope.status.isAddPersonalMaterial, true);
            xhr.onload = function(evt) {
                onload(evt.currentTarget.responseText, index);
                // console.log(evt.currentTarget.responseText);
            };
            xhr.onerror = function(evt) {
                onerror('上传失败，请重新上传', index);
            };
            xhr.upload.onprogress = function(evt) {
                // console.log("进度条");
                // console.log(evt);
                onProgress(evt, index);
            };
            xhr.upload.onloadstart = function() {
                // console.log("开始传了");
            };
            xhr.onreadystatechange = function() {
                var status = xhr.readyState;
                if (status == 4 && xhr.status == 200) {
                    var b = JSON.parse(xhr.responseText);
                    isPersonal(b, index);
                }
            };
            xhr.send(fd);
        }

        /**
         * [isAddPersonalMaterial description]是否保存至个人素材库
         * @return {Boolean} [description]
         */
        $scope.isAddPersonalMaterial = function() {
            $scope.status.isAddPersonalMaterial = !$scope.status.isAddPersonalMaterial;
        };

        /**
         * [uploadends] 上传是否正在进行
         * @return {[type]} [description]
         */
        $scope.uploadIsRunning = function() {
            var flag = false;
            for (var i = 0; i < $scope.data.picList.length; i++) {
                if ($scope.data.picList[i].progress !== undefined && $scope.data.picList[i].progress !== '100%') {
                    flag = true;
                }
            }
            return flag;
        };

        /**
         * [uploadEnd] 是否所有图片上传完成
         * @return {[type]} [description]
         */
        $scope.uploadEnd = function() {
            for (var i = 0; i < $scope.data.picList.length; i++) {
                if ($scope.data.picList[i].realSrc === undefined) {
                    return false;
                }
            }
            return true;
        };

        /**
         * [getContentHeight] 控制content的高度
         * @return {[type]} [description]
         */
        function getContentHeight() {
            $timeout(function() {
                if ($scope.data.picList.length == 0) {
                    var hei;
                    var bodyHei = $('.uploadRsource .body').height();
                    hei = bodyHei - 47;
                    $('.uploadRsource .body .content').css({ height: hei + 'px' });
                } else {
                    $('.uploadRsource .body .content').css({ height: 'auto' });
                }
            });
        }

        /**
         * [confirm] 确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            var flag = $scope.uploadEnd(); // 图片是否上传完成 ture为是 false为否
            if (!flag) {
                modalDialog.alertType('您还有未上传完成的图片', '', 'warning', false);
                return;
            }
            isSavePersonal();
            $templateRequest('./components/util/ueditor/service/imageNote/pictureComponent_tpl.html').then(function(template) {
                var newHtml = '';
                var piclist = $scope.data.picList;
                for (var i = 0; i < piclist.length; i++) {
                    if (!angular.isDefined(piclist[i].error)) {
                        var dom = document.createElement('div');
                        dom.innerHTML = template;
                        if (piclist[i].realSrc !== undefined) {
                            var fileInfo = piclist[i];
                            fileInfo.tuShuo = fileInfo.tuShuo === undefined ? '' : fileInfo.tuShuo;
                            var uploadpic = fileInfo.realSrc.split('=')[1];
                            $(dom)
                                .find('.app_image_wrap')
                                .css({
                                    textAlign: 'center',
                                });
                            $(dom)
                                .find('img')
                                .attr('src', fileInfo.realSrc);
                            $(dom)
                                .find('img')
                                .attr('uploadpic', uploadpic);
                            $(dom)
                                .find('img')
                                .css({
                                    // display: 'block',
                                    clear: 'both',
                                    // maxWidth: 1200,
                                    margin: '0 auto',
                                });
                            $(dom)
                                .find('.imagenote')
                                .css({
                                    marginTop: 1,
                                    paddingTop: 1,
                                    fontSize: 14,
                                    height: 'auto',
                                    color: '#8a939e',
                                    paddingBottom: 6,
                                    textAlign: 'left',
                                    boxSizing: 'initial',
                                    lineHeight: '1.5em',
                                });
                            if (fileInfo.tuShuo === '') {
                                $(dom)
                                    .find('.imagenote')
                                    .html('请输入图片描述');
                            } else {
                                $(dom)
                                    .find('.imagenote')
                                    .html(fileInfo.tuShuo.replace(/\n/g, '<br/>').replace(/ /g, '　'));
                            }
                        }
                        newHtml += $(dom).html();
                    }
                }
                $modalInstance.close(newHtml);
            });
        };

        /**
         * [isSavePersonal description]是否储存到个人素材
         * @return {Boolean} [description]
         */
        function isSavePersonal() {
            if ($scope.status.isAddPersonalMaterial == true) {
                var newIsPersonal = new Array();
                var isPersonal = angular.copy($scope.data.PersonalMaterialOfImgs);
                for (var i = 0; i < isPersonal.length; i++) {
                    if (!isPersonal[i]) {
                        continue;
                    }
                    var obj = {};
                    obj.fileDesc = isPersonal[i].orignalImg;
                    obj.PersonalMaterialId = '0';
                    obj.fileSize = String(isPersonal[i].fileSizeOfKB);
                    obj.fileName = isPersonal[i].imgName;
                    newIsPersonal.push(obj);
                }
                var params = {
                    methodname: 'addPersonalMaterialOfImgs',
                    serviceid: 'mlf_releaseSource',
                    PersonalMaterialOfImgs: JSON.stringify(newIsPersonal),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {});
            }
        }

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            requestData();
            $scope.callBack = {
                success: function(file, src, uploader) {
                    getuploaderData(src, file).then(function(data) {
                        if (data.length === $scope.data.uploadImgs.length) {
                            if ($scope.data.selectedArray.length > 0) {
                                addMyPictures(data);
                            } else {
                                $modalInstance.close(data);
                            }
                        }
                    });
                },
                error: function(file) {
                    // $modalInstance.dismiss();
                },
                file: function(file, uploader) {
                    // console.log(file);
                    angular.forEach(file, function(value, key) {
                        uploader.makeThumb(value, function(error, src) {
                            $timeout(function() {
                                $scope.data.uploadImgs.push({
                                    src: src,
                                    id: value.id,
                                    appsort: parseInt(value.id.substring(8)),
                                });
                                if ($scope.data.uploadImgs.length === file.length) {
                                    $scope.data.uploadImgs.sort(function(x, y) {
                                        return x.appsort > y.appsort ? 1 : -1;
                                    });
                                }
                            }, 200);
                        });
                    });

                    $scope.theFinish = function() {
                        uploader.upload();
                    };
                },
                tar: function(file, percentage) {
                    var per = Math.ceil(percentage * 100) + '%';
                    $timeout(function() {
                        $scope.data.progress[file.id] = per;
                    });
                },
                comp: function(file) {},
            };
        }

        /**
         * [finish description] 完成
         * @return {[type]} [description]
         */
        $scope.finish = function() {
            $scope.status.lockBtn = true;
            if ($scope.data.uploadImgs.length === 0) {
                var data = [];
                addMyPictures(data);
            } else {
                $scope.theFinish();
            }
            $scope.data.selectedNav = 2;
        };

        /**
         * [requestData description] 请求我的图片数据
         * @return {[type]} [description]
         */
        function requestData() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.data.myPictures = data.DATA;
                $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT; // 页数
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT; // 文件数量
                getContentHeight();
                getFileRoutes();
            });
        }

        /**
         * [getFileRoutes description] 获取当前文件的导航
         * @return {[type]} [description]
         */
        function getFileRoutes() {
            if ($scope.data.currFileId == '0') {
                $scope.status.isShowRoutes = false;
                return;
            } else {
                var params = {
                    serviceid: 'mlf_releaseSource',
                    methodname: 'getPersonalMaterialDaoHang',
                    PersonalMaterialId: $scope.data.currFileId,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    var rootRoute = [
                        {
                            FILEDESC: '全部文件',
                            PERSONALMATERIALID: '0',
                            fileTitle: '全部文件',
                        },
                    ];
                    data.sort(function(x, y) {
                        return 1;
                    });
                    $scope.data.allRoutes = rootRoute.concat(data);
                    $scope.status.isShowRoutes = true;
                });
            }
        }

        /**
         * [turnBackToPreviousRoute description] 返回上一级目录
         * @return {[type]} [description]
         */
        $scope.turnBackToPreviousRoute = function() {
            var routesLength = $scope.data.allRoutes.length;
            var route = $scope.data.allRoutes[routesLength - 2];
            turnBack(route);
        };

        /**
         * [turnBackToAllFile description] 返回全部文件
         * @return {[type]} [description]
         */
        $scope.turnBackToAllFile = function() {
            var route = $scope.data.allRoutes[0];
            turnBack(route);
        };

        /**
         * [turnBack description] 返回指定目录
         * @param  {[type]} route [description] 指定目录
         * @return {[type]}       [description]
         */
        function turnBack(route) {
            $scope.params.searchValue = '';
            $scope.data.keywords = '';
            $scope.params.PersonalMaterialId = route.PERSONALMATERIALID;
            $scope.data.currFileId = route.PERSONALMATERIALID;
            $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
            $scope.status.copyCurrPage = 1;
            requestData();
        }

        /**
         * [search description] 搜索
         * @param  {[type]} ev [description] 键盘按键
         * @return {[type]}    [description]
         */
        $scope.search = function(ev) {
            if (angular.isDefined(ev) && ev.keyCode == 13) {
                $scope.params.searchValue = angular.copy($scope.data.keywords);
                $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                $scope.status.copyCurrPage = 1;
                requestData();
            }
        };

        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description] 选中的文件
         * @return {[type]}      [description]
         */
        // 列表单选框 点击选中
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0 && item.FILESIZE != '0') {
                $scope.data.selectedArray.push(item);
            } else if ($scope.data.selectedArray.indexOf(item) >= 0 && item.FILESIZE != '0') {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [findChildrenFile description] 查看文件夹内的子文件，或文件详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.findChildrenFile = function(item) {
            if (item.FILETYPE == '0') {
                $scope.params.searchValue = '';
                $scope.data.keywords = '';
                $scope.params.PersonalMaterialId = item.PERSONALMATERIALID;
                $scope.data.currFileId = item.PERSONALMATERIALID;
                $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                $scope.status.copyCurrPage = 1;
                requestData();
            }
        };

        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
            $('.uploadContent').animate({ scrollTop: 0 }, 'fast');
        };

        /**
         * [getuploaderData description]获得图片上传后的路径和文件名
         * @param  {[ob]} src  [description]图片上传后的地址
         * @param  {[obj]} file [description]图片队列
         * @return {[type]}      [description]
         */
        function getuploaderData(src, file) {
            var deferred = $q.defer();
            $scope.data.uploadedSrcs.push({
                PERPICURL: src.imgSrc,
                APPFILE: src.imgName,
                APPDESC: file.name.replace(/\.\w+$/, ''),
                APPSORT: file.id.substr(file.id.length - 1, 1),
                APPSIZE: src.fileSizeOfKB,
            });
            deferred.resolve($scope.data.uploadedSrcs);
            return deferred.promise;
        }

        /**
         * [addMyPictures description] 添加我的图片
         * @param {[type]} uploadPic [description]
         */
        function addMyPictures() {
            for (var l = 0; l < $scope.data.selectedArray.length; l++) {
                $scope.data.picList.unshift({
                    lastModified: new Date($scope.data.selectedArray[l].CRTIME).getTime(),
                    lastModifiedDate: new Date(new Date($scope.data.selectedArray[l].CRTIME).getTime()),
                    name: $scope.data.selectedArray[l].FILEDESC,
                    previewSrc: $scope.data.selectedArray[l].SRCIMGURL,
                    realSrc: $scope.data.selectedArray[l].SRCIMGURL,
                    size: $scope.data.selectedArray[l].FILESIZE * 1024,
                    type: '',
                    webkitRelativePath: '',
                    progress: '100%',
                    isSuCaiKu: true,
                });
            }
            $scope.data.selectedArray = [];
        }

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss('cancel');
        };
    },
]);
